import { combineReducers } from "redux";
import authReducer from "./auth";
import dashboardReducer from "./dashboard";
import staffReducer from "./staff";
import facilityReducer from "./facility";
import noteReducer from "./note";
import patientReducer from "./patient";
import profileReducer from "./profile";
import reportReducer from "./report";
import medicationReducer from "./medication";
import supportPlanReducer from "./supportplan";
import ticketReducer from "./ticket";
import taskReducer from "./task";
import marReducer from "./mar";
import documentReducer from "./document";
import notificationReducer from "./notification";
import themeReducer from "./theme";
import billingprovider from "./billingprovider";
import BillingReducer from "./billing";
import PayerReducer from "./payer";
import ServiceCodeReducer from "./servicecode";
import billingclient from "./billingclient";
import billinginvoiceReducer from "./billinginvoice";
import settinginvoiceReducer from "./settinginvoice";
import featureFlagsReducer from "./split";
import skaiSlice from "./skaiSlice";
import signatureReducer from "./signature";
import skypointProviderReducer from "./skypointProvider";
import complianceReducer from "./compliance";
import schedulerReducer from "./scheduler";


const combinedReducer = combineReducers({
  auth: authReducer,
  dashboard: dashboardReducer,
  staff: staffReducer,
  facility: facilityReducer,
  note: noteReducer,
  patient: patientReducer,
  profile: profileReducer,
  report: reportReducer,
  medication: medicationReducer,
  supportPlan: supportPlanReducer,
  ticket: ticketReducer,
  task: taskReducer,
  mar: marReducer,
  document: documentReducer,
  notification: notificationReducer,
  theme: themeReducer,
  billing: BillingReducer,
  payer: PayerReducer,
  servicecode: ServiceCodeReducer,
  billingprovider: billingprovider,
  billingclient: billingclient,
  billinginvoiceReducer: billinginvoiceReducer,
  settinginvoice: settinginvoiceReducer,
  featureFlags: featureFlagsReducer,
  skai: skaiSlice,
  signature: signatureReducer,
  skypointProviders: skypointProviderReducer,
  compliance: complianceReducer,
  scheduler: schedulerReducer,
});

const rootReducer = (state, action) => {
  if (action.type === "RESET_STORE") {
    state = undefined;
  }
  return combinedReducer(state, action);
};

export default rootReducer;
